<template>
    <div class="vm-markdown-html">
        <pre v-if="value != ''">{{ value }}</pre>
        <div v-else class="md-loading">
            <span class="md-spinner"></span>
            Yükleniyor...
        </div>
    </div>
</template>

<script>
import Marked from 'marked'
import HLJS from './lib/highlight'
import {objectDeepMerge, objectStyleToStringStyle} from './lib/util'
import axios from 'axios'

const defaultRequestConfig = {
  method: 'get',
  responseType: 'blob'
}

export default {
  name: 'MarkdownViewer',
  props: {
    mdStyle: {
      type: Object
    },
    url: {
      type: String,
      default: ''
    },
  },
  data: function () {
    return {
      codeBgColor: 'rgb(248, 248, 248)',
      defaultStyle: {
        ul: {
          margin: '10px 20px',
          'list-style-type': 'square',
          padding: '0'
        },
        ol: {
          margin: '10px 20px',
          'list-style-type': 'decimal',
          padding: '0'
        },
        li: {
          display: 'list-item',
          padding: '0'
        },
        hr: {
          margin: '15px 0',
          'border-top': '1px solid #EFEFEF'
        },
        pre: {
          display: `block`,
          margin: `10px 0`,
          padding: `8px`,
          'border-radius': `8px`,
          'background-color': `#F5F7FA`,
          color: `#333333`,
          'font-size': `13px`
        },
        blockquote: {
          display: `block`,
          'border-left': `4px solid #E6E9EE`,
          margin: `15px 0`,
          padding: `0 15px`
        },
        img: {
          margin: `20px 0`
        },
        a: {
          color: `#097DFF`
        },
        table: {
          border: `1px solid #E6E9EE`,
          'border-collapse': `collapse`
        },
        tr: {
          border: `1px solid #E6E9EE`
        },
        th: {
          padding: `8px 30px`,
          'border-right': `1px solid #E6E9EE`,
          'background-color': `#F5F7FA`
        },
        td: {
          padding: `8px 30px`,
          'border-right': `1px solid #E6E9EE`
        },
        code: {
          'background-color': `#F5F7FA`
        },
      },
      value: ''
    }
  },
  watch: {
    value: function (val) {
      this.updateContent(val)
    }
  },
  computed: {
    actualValue: function () {
        this.tempValueC()
        return this.value
    }
  },
  mounted: function () {
    this.updateContent(this.actualValue)
  },
  methods: {
    tempValueC: function () {
        Object.assign(defaultRequestConfig, this.requestConfig, {url: this.url})
        this.download(defaultRequestConfig).then(data => {
        this.value = data;
        }).catch(err => {
            this.value = 'Download Error!'
            console.error(err)
        })
    },
    download: function (config) {
      return new Promise((resolve, reject) => {
        axios(config).then(res => {
          const reader = new FileReader()
          reader.readAsText(new Blob([res.data]))
          reader.onload = function () {
            resolve(reader.result)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    updateContent: function (val) {
      if (val) {
        const parseMarked = Marked.parse(val)
        this.value = parseMarked
        this.parseHtml()
        HLJS.highlightBlock()
      }
    },
    parseHtml: function () {
      let styleObj = this.mdStyle ? objectDeepMerge(this.defaultStyle, this.mdStyle) : this.defaultStyle
      let styleBlocks = Object.keys(styleObj)
      let style = {}
      styleBlocks.forEach(name => {
        style[name] = objectStyleToStringStyle(styleObj[name])
      })
      let html = document.getElementsByClassName('vm-markdown-html')[0]
      if (html) {
        let tagNames = Object.keys(style)
        for (let i = 0; i < tagNames.length; i++) {
          let _tagNames = html.getElementsByTagName(tagNames[i])
          if (_tagNames.length > 0) {
            for (let j = 0; j < _tagNames.length; j++) {
              _tagNames[j].style.cssText = style[tagNames[i]]
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
/* Voya: kod / markdown görüntüleyici */
.vm-markdown-html {
    box-sizing: border-box;
    margin: 56px 12px calc(env(safe-area-inset-bottom, 0px) + 24px) 12px;
    padding: 16px;
    border: 1px solid #EFEFEF;
    border-radius: 16px;
    background-color: #ffffff;
    box-shadow: 0 2px 12px rgba(9, 33, 84, 0.06);
    font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
    color: #333333;
    overflow: auto;
    flex-grow: 1;
    word-wrap: break-word;
}

.vm-markdown-html ul {
    margin: 10px 20px;
    list-style-type: square;
    padding: 0;
}

.vm-markdown-html ol {
    margin: 10px 20px;
    list-style-type: decimal;
    padding: 0;
}

.vm-markdown-html li {
    display: list-item;
    padding: 0;
}

.vm-markdown-html hr {
    margin: 15px 0;
    border-top: 1px solid #EFEFEF;
}

.vm-markdown-html pre {
    display: block;
    margin: 0;
    padding: 8px;
    border-radius: 8px;
    background-color: #F5F7FA;
    color: #333333;
    font-size: 13px;
}

.vm-markdown-html blockquote {
    display: block;
    border-left: 4px solid #E6E9EE;
    margin: 15px 0;
    padding: 0 15px;
}

.vm-markdown-html img {
    margin: 20px 0;
}

.vm-markdown-html a {
    color: #097DFF;
}

.vm-markdown-html table {
    border: 1px solid #E6E9EE;
    border-collapse: collapse;
}

.vm-markdown-html tr {
    border: 1px solid #E6E9EE;
}

.vm-markdown-html th {
    padding: 8px 30px;
    border-right: 1px solid #E6E9EE;
    background-color: #F5F7FA;
}

.vm-markdown-html td {
    padding: 8px 30px;
    border-right: 1px solid #E6E9EE;
}

.vm-markdown-html code {
    background-color: #F5F7FA;
}

.md-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 60px 0;
    font-weight: 500;
    font-size: 13px;
    color: #808080;
}

.md-spinner {
    width: 18px;
    height: 18px;
    border: 2px solid #FCE3CE;
    border-top-color: #F37615;
    border-radius: 50%;
    animation: md-spin 0.8s linear infinite;
}

@keyframes md-spin {
    to {
        transform: rotate(360deg);
    }
}

</style>
